import { z } from "zod/v4";

import { castToNumber } from "../utils";
// import { OfferProductInclusionTypeList } from "./product-variants";

export const OfferProductInclusionTypeList = ["include", "exclude"] as const;
export type OfferProductInclusionType =
  (typeof OfferProductInclusionTypeList)[number];

export const OfferProductVariantDtoSchema = z.object({
  id: z.string().describe("Product variant ID from your catalog"),
  title: z.string().describe("Product variant display name"),
  price: castToNumber.describe("Current price of the variant"),
  compareAtPrice: castToNumber
    .nullish()
    .describe("Compare-at (original) price if on sale"),
});

export type OfferProductVariantDto = z.infer<
  typeof OfferProductVariantDtoSchema
>;

export const OfferProductDtoSchema = z.object({
  id: z.string().describe("Product ID from your catalog"),
  title: z.string().describe("Product display name"),
  image: z.string().nullish().describe("Product image URL"),
  variants: OfferProductVariantDtoSchema.array().describe(
    "Specific product variants to include/exclude"
  ),
  variationId: z
    .uuid()
    .describe("Variation this product configuration belongs to"),
  offerId: z
    .uuid()
    .nullable()
    .describe("Offer this product is associated with"),
  inclusionType: z
    .enum(OfferProductInclusionTypeList)
    .optional()
    .default("include")
    .describe("Whether to 'include' or 'exclude' this product from offers"),
});

export type OfferProductDto = z.infer<typeof OfferProductDtoSchema>;
